'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ChartDownloadButtonItems = exports.ChartDownloadButtonItems = undefined;

exports.ChartDownloadButtonItems = ChartDownloadButtonItems = function ChartDownloadButtonItems(refs) {
    var uiManager = refs.uiManager,
        instanceManager = refs.instanceManager,
        i18n = refs.i18nManager.get();

    var getFilename = function getFilename() {
        return instanceManager.getStateFavoriteName() || instanceManager.getStateCurrent().title || i18n.untitled;
    };

    return [{
        xtype: 'label',
        text: i18n.graphics,
        style: 'padding:7px 5px 5px 7px; font-weight:bold'
    }, {
        text: i18n.image_png + ' (.png)',
        iconCls: 'ns-menu-item-image',
        handler: function handler() {
            uiManager.submitSvgForm('png', getFilename());
        }
    }, {
        text: 'PDF (.pdf)',
        iconCls: 'ns-menu-item-image',
        handler: function handler() {
            uiManager.submitSvgForm('pdf', getFilename());
        }
    }];
};
//# sourceMappingURL=ChartDownloadButtonItems.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/ChartDownloadButtonItems.js
 ** module id = 151
 ** module chunks = 0 1
 **/